
import ApplicationApi from '@/api/applicationApi'
const api = new ApplicationApi()

export default {
  async getStatuses(context, payload) {
    let statuses = context.getters.getStatuses
    if (!statuses?.length || payload) {
      return await api.getStatuses()
    } else {
      return statuses
    }
  },
  
  async getCreateOrdersUsers(context, payload) {
    let users = context.getters.getCreateOrdersUsers
    if (!users?.length || payload) {
      return await api.createOrdersUsers()
    } else {
      return users
    }
  },

  async getPurchasingPlans(context, {filters, unionType}) {
    let rows = context.getters.getPurchasingPlan
    if (!rows?.length || filters) {
      return await api.purchasingPlan(filters, unionType).then(res => {
        context.commit('setPurchasingPlan', res)
        return res
      })
    } else {
      return rows
    }
  },
}